import { apiClient } from "../lib/api";

export const storeApi = {
  list: (includeInactive = true) => apiClient.get("/stores", { params: { include_inactive: includeInactive } }),
  create: (payload) => apiClient.post("/stores", payload),
  update: (id, payload) => apiClient.patch(`/stores/${id}`, payload),
  deactivate: (id) => apiClient.post(`/stores/${id}/deactivate`),
  reactivate: (id) => apiClient.post(`/stores/${id}/reactivate`),
};

export const storeScopeApi = {
  summary: () => apiClient.get("/users/store-scopes/summary"),
  get: (userId) => apiClient.get(`/users/${userId}/store-scope`),
  assign: (userId, payload) => apiClient.post(`/users/${userId}/store-scope`, payload),
};
